export const jsonToBase64 = (json: object) =>
  window.btoa(decodeURI(encodeURIComponent(JSON.stringify(json))));

export const base64ToJson = (base64: string) =>
  JSON.parse(decodeURIComponent(window.atob(base64).replace('/x', '%')));
